import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SvgIcon from '@mui/material/SvgIcon';
import Users03Icon from 'src/icons/untitled-ui/duocolor/users-03';
import { tokens } from 'src/locales/tokens';
import { paths } from 'src/paths';
import { Quiz, ReportOutlined, Restaurant, Settings } from '@mui/icons-material';
import { DataHelper } from 'src/services/dataHelper';
import toast from 'react-hot-toast';
import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';

export const useSections = () => {
  const { t } = useTranslation();

  useEffect(() => {
  }, []);

  return useMemo(() => {
    return [
      {
        items: [
          {
            title: t(tokens.nav.dashboard),
            path: paths.dashboard.index,
            icon: (
              <SvgIcon fontSize="small">
                <HomeSmileIcon />
              </SvgIcon>
            )
          },
          //settings
          {
            title: t(tokens.nav.settings),
            path: paths.dashboard.country.index,
            icon: (
              <SvgIcon fontSize="small">
                <Settings />
              </SvgIcon>
            ),
            items: [
              {
                title: t(tokens.nav.user),
                path: paths.dashboard.user.userList
              },
       
            ]
          },

          // restaurant
          {
            title: t(tokens.nav.quiz),
            path:  paths.questionBank.question.questionList,
            icon: (
              <SvgIcon fontSize="small">
                <Quiz />
              </SvgIcon>
            ),
            items: [
              {
                title: t(tokens.nav.questionAnswer),
                path: paths.questionBank.question.questionList
              },       
            ]
          },


        ]
      },
    ];
  }, [t]);  
};
